// import { Formik } from 'formik'
// import React, { useState } from 'react'
// import * as Yup from 'yup'
// import {
//   // useDispatch,
//   useSelector
// } from 'react-redux'
// // import { setFrProUser } from '../../../../store/reducers/Users/users'
// import InputField from '../../../../Components/inputField'
// import { ProfileApis } from '../../../../API/Login/ProfileApi'
// import PropTypes from 'prop-types'
// import FleetBusinessSummarySkeleton from './FleetBusinessSummaryView'
// import Toasts from '../../../../Components/Toasts/Toasts'
// import ErrorHandle from '../../../../Components/ErrorHandle'

// const FleetBuisinessSummary = ({ setSelection }) => {
//   // const dispatch = useDispatch()
//   const { frProUser } = useSelector((state) => state.Users)
//   const [saving, setSaving] = useState(
//     frProUser?.updateProfileForm?.businessName?.length > 0 ? true : false
//   )

//   const [toasts, setToasts] = useState(null)

//   const deleteBusinessSummaryData = {
//     ...frProUser?.updateProfileForm,
//     fre8ProAccessToken: frProUser?.fre8ProAccessToken,
//     businessName: '',
//     businessLegalName: '',
//     businessNumber: '',
//     einNumber: '',
//   }

//   return (
//     <div>
//       {saving ? (
//         <FleetBusinessSummarySkeleton
//           setSaving={setSaving}
//           setSelection={setSelection}
//           deleteBusinessSummaryData={deleteBusinessSummaryData}
//           setToasts={setToasts}
//         />
//       ) : (
//         <Formik
//           initialValues={{
//             businessName: frProUser?.updateProfileForm?.businessName
//               ? frProUser?.updateProfileForm?.businessName
//               : '',
//             businessLegalName: frProUser?.updateProfileForm?.businessLegalName
//               ? frProUser?.updateProfileForm?.businessLegalName
//               : '',
//             businessNumber: frProUser?.updateProfileForm?.businessNumber
//               ? frProUser?.updateProfileForm?.businessNumber
//               : '',
//             einNumber: frProUser?.updateProfileForm?.einNumber
//               ? frProUser?.updateProfileForm?.einNumber
//               : '',
//           }}
//           validationSchema={Yup.object().shape({
//             // firstname: Yup.string(),
//           })}
//           onSubmit={async (values, { setErrors, setStatus, setSubmitting }) => {
//             try {
//               const data = {
//                 ...frProUser?.updateProfileForm,
//                 fre8ProAccessToken: frProUser?.fre8ProAccessToken,
//                 ...values,
//               }
//               console.log(data)
//               ProfileApis.updateFleetOwnerUserProfile(data).then(() => {
//                 {/* dispatch(
//                   setFrProUser({
//                     frProUser: {
//                       ...frProUser,
//                       updateProfileForm: {
//                         ...frProUser?.updateProfileForm,
//                         ...values,
//                       },
//                     },
//                   })
//                 ) */}
//               })
//               setSaving(true)
//             } catch (err) {
//               console.error(err)
//               let customMessage = 'User Business summary update failed'
//               let type = 'User Profile'
//               let color = 'red'
//               ErrorHandle(err, setToasts, customMessage, type, color)
//             }
//           }}
//         >
//           {({ errors, handleSubmit, touched, values }) => (
//             <form onSubmit={handleSubmit}>
//               <div>
//                 <div className="mb-4 p-4 shadow-sm rounded-4 bg-white">
//                   <h5 className="fw-bold mb-3">Business summary</h5>
//                   <div className="row">
//                     <div className="col-md-7 ms-auto">
//                       <div className="row g-4">
//                         <div className="col-md-12">
//                           <label className="form-label">
//                             Business name{' '}
//                             <span style={{ color: 'red' }}>*</span>
//                           </label>
//                           <InputField
//                             type={'text'}
//                             values={values}
//                             // editMode={editMode}
//                             name={'businessName'}
//                             maxLength={50}
//                             touched={touched}
//                             errors={errors}
//                           />
//                         </div>
//                         <div className="col-md-12">
//                           <label className="form-label">
//                             Legal business name{' '}
//                             <span style={{ color: 'red' }}>*</span>
//                           </label>
//                           <InputField
//                             type={'text'}
//                             values={values}
//                             // editMode={editMode}
//                             name={'businessLegalName'}
//                             touched={touched}
//                             errors={errors}
//                           />
//                         </div>
//                         <div className="col-md-12 col-lg-8">
//                           <label className="form-label">
//                             Business number{' '}
//                             <span style={{ color: 'red' }}>*</span>
//                           </label>
//                           <InputField
//                             type={'text'}
//                             values={values}
//                             // editMode={editMode}
//                             name={'businessNumber'}
//                             touched={touched}
//                             errors={errors}
//                           />
//                         </div>
//                         <div className="col-md-12 col-lg-8">
//                           <label className="form-label">
//                             EIN number <span style={{ color: 'red' }}>*</span>
//                           </label>
//                           <InputField
//                             type={'text'}
//                             values={values}
//                             // editMode={editMode}
//                             name={'einNumber'}
//                             touched={touched}
//                             errors={errors}
//                           />
//                         </div>

//                         <div className="mt-4">
//                           <button
//                             type={'submit'}
//                             className="btn btn-theme me-2"
//                           >
//                             Save
//                           </button>
//                           <button
//                             type="button"
//                             className="btn btn-border"
//                             // data-bs-dismiss="modal"
//                             onClick={() =>
//                               frProUser?.updateProfileForm?.businessName
//                                 ? setSaving(true)
//                                 : setSelection('')
//                             }
//                           >
//                             Cancel
//                           </button>
//                         </div>
//                       </div>
//                     </div>
//                   </div>
//                 </div>
//               </div>
//             </form>
//           )}
//         </Formik>
//       )}
//       {toasts && <Toasts toastsList={toasts} />}
//     </div>
//   )
// }

// export default FleetBuisinessSummary

// FleetBuisinessSummary.propTypes = {
//   setSelection: PropTypes.func,
// }
// import { Formik, FieldArray } from "formik";
// import React, { useState } from "react";
// import { useSelector } from "react-redux";
// import * as Yup from "yup";

// import InputField from "../../../../Components/inputField";
// import { ProfileApis } from "../../../../API/Login/ProfileApi";
// import PropTypes from "prop-types";
// import FleetBusinessSummarySkeleton from "./FleetBusinessSummaryView";
// import Toasts from "../../../../Components/Toasts/Toasts";
// import ErrorHandle from "../../../../Components/ErrorHandle";

// const FleetBusinessSummary = ({ setSelection }) => {
//   const { frProUser } = useSelector((state) => state.Users);

//   const [saving, setSaving] = useState(
//     frProUser?.updateProfileForm?.businessName?.length > 0 ? true : false
//   );

//   const [toasts, setToasts] = useState(null);

//   const deleteBusinessSummaryData = {
//     ...frProUser?.updateProfileForm,
//     fre8ProAccessToken: frProUser?.fre8ProAccessToken,
//     businessName: "",
//     businessLegalName: "",
//     businessNumber: "",
//     einNumber: "",
//   };

//   return (
//     <div>
//       {saving ? (
//         <FleetBusinessSummarySkeleton
//           setSaving={setSaving}
//           setSelection={setSelection}
//           deleteBusinessSummaryData={deleteBusinessSummaryData}
//           setToasts={setToasts}
//         />
//       ) : (
//         <Formik
//           initialValues={{
//             businessName: frProUser?.updateProfileForm?.businessName || "",
//             businessLegalName:
//               frProUser?.updateProfileForm?.businessLegalName || "",
//             businessNumber: frProUser?.updateProfileForm?.businessNumber || "",
//             einNumber: frProUser?.updateProfileForm?.einNumber || "",
//             businessDescription:
//               frProUser?.updateProfileForm?.businessDescription || "",
//             businessNumbers:
//               frProUser?.updateProfileForm?.businessNumbers || [],
//             secondaryEmails:
//               frProUser?.updateProfileForm?.secondaryEmails || [],
//             secondaryMobiles:
//               frProUser?.updateProfileForm?.secondaryMobiles || [],
//           }}
//           validationSchema={Yup.object().shape({})}
//           onSubmit={async (values) => {
//             try {
//               const data = {
//                 ...frProUser?.updateProfileForm,
//                 ...values,
//                 fre8ProAccessToken: frProUser?.fre8ProAccessToken,
//               };

//               await ProfileApis.updateFleetOwnerUserProfile(data);
//               setSaving(true);
//             } catch (err) {
//               ErrorHandle(
//                 err,
//                 setToasts,
//                 "User Business summary update failed",
//                 "User Profile",
//                 "red"
//               );
//             }
//           }}
//         >
//           {({ errors, handleSubmit, touched, values }) => (
//             <form onSubmit={handleSubmit}>
//               <div className="mb-4 p-4 shadow-sm rounded-4 bg-white">
//                 <h5 className="fw-bold mb-3">Business Summary</h5>

//                 <div className="row">
//                   <div className="col-md-7 ms-auto">
//                     <div className="row g-4">
//                       {/* Business Name */}
//                       <div className="col-md-12">
//                         <label className="form-label">
//                           Business name <span style={{ color: "red" }}>*</span>
//                         </label>
//                         <InputField
//                           type="text"
//                           name="businessName"
//                           values={values}
//                           touched={touched}
//                           errors={errors}
//                           maxLength={50}
//                         />
//                       </div>

//                       {/* Legal Name */}
//                       <div className="col-md-12">
//                         <label className="form-label">
//                           Legal business name{" "}
//                           <span style={{ color: "red" }}>*</span>
//                         </label>
//                         <InputField
//                           type="text"
//                           name="businessLegalName"
//                           values={values}
//                           touched={touched}
//                           errors={errors}
//                         />
//                       </div>

//                       {/* Business Summary Textarea */}
//                       <div className="col-md-12">
//                         <label className="form-label">Business Summary</label>
//                         <InputField
//                           tag="textarea"
//                           rows="4"
//                           name="businessDescription"
//                           values={values}
//                           touched={touched}
//                           errors={errors}
//                           placeholder="Enter business summary"
//                         />
//                       </div>

//                       {/* Dynamic Business Numbers */}
//                       <div className="col-md-12">
//                         <FieldArray
//                           name="businessNumbers"
//                           render={(arrayHelpers) => (
//                             <>
//                               <div className="d-flex justify-content-between align-items-center mb-2">
//                                 <label className="form-label">
//                                   Business Numbers
//                                 </label>
//                                 <button
//                                   type="button"
//                                   className="btn btn-sm btn-primary"
//                                   onClick={() =>
//                                     arrayHelpers.push({
//                                       type: "",
//                                       number: "",
//                                     })
//                                   }
//                                 >
//                                   Add Business Number
//                                 </button>
//                               </div>

//                               {values.businessNumbers?.map((item, index) => (
//                                 <div className="row mb-2" key={index}>
//                                   <div className="col-md-4">
//                                     <label>Type {index + 1}</label>
//                                     <InputField
//                                       name={`businessNumbers.${index}.type`}
//                                       values={values}
//                                       touched={touched}
//                                       errors={errors}
//                                       placeholder="PAN / GST / EIN"
//                                     />
//                                   </div>

//                                   <div className="col-md-6">
//                                     <label>Business Number {index + 1}</label>
//                                     <InputField
//                                       name={`businessNumbers.${index}.number`}
//                                       values={values}
//                                       touched={touched}
//                                       errors={errors}
//                                     />
//                                   </div>

//                                   <div className="col-md-2 d-flex align-items-end">
//                                     <button
//                                       type="button"
//                                       className="btn btn-danger btn-sm"
//                                       onClick={() => arrayHelpers.remove(index)}
//                                     >
//                                       X
//                                     </button>
//                                   </div>
//                                 </div>
//                               ))}
//                             </>
//                           )}
//                         />
//                       </div>

//                       {/* Dynamic Secondary Emails */}
//                       <div className="col-md-12">
//                         <FieldArray
//                           name="secondaryEmails"
//                           render={(arrayHelpers) => (
//                             <>
//                               <div className="d-flex justify-content-between mb-2">
//                                 <label className="form-label">
//                                   Secondary Emails
//                                 </label>
//                                 <button
//                                   type="button"
//                                   className="btn btn-sm btn-primary"
//                                   onClick={() => arrayHelpers.push("")}
//                                 >
//                                   Add Secondary Email
//                                 </button>
//                               </div>

//                               {values.secondaryEmails?.map((email, index) => (
//                                 <div className="row mb-2" key={index}>
//                                   <div className="col-md-10">
//                                     <InputField
//                                       name={`secondaryEmails.${index}`}
//                                       values={values}
//                                       touched={touched}
//                                       errors={errors}
//                                       placeholder={`Secondary Email ${index + 1
//                                         }`}
//                                     />
//                                   </div>

//                                   <div className="col-md-2 d-flex align-items-end">
//                                     <button
//                                       type="button"
//                                       className="btn btn-danger btn-sm"
//                                       onClick={() => arrayHelpers.remove(index)}
//                                     >
//                                       X
//                                     </button>
//                                   </div>
//                                 </div>
//                               ))}
//                             </>
//                           )}
//                         />
//                       </div>

//                       {/* Dynamic Secondary Mobile Numbers */}
//                       <div className="col-md-12">
//                         <FieldArray
//                           name="secondaryMobiles"
//                           render={(arrayHelpers) => (
//                             <>
//                               <div className="d-flex justify-content-between mb-2">
//                                 <label className="form-label">
//                                   Secondary Mobile Numbers
//                                 </label>
//                                 <button
//                                   type="button"
//                                   className="btn btn-sm btn-primary"
//                                   onClick={() => arrayHelpers.push("")}
//                                 >
//                                   Add Secondary Number
//                                 </button>
//                               </div>

//                               {values.secondaryMobiles?.map(
//                                 (num, index) => (
//                                   <div className="row mb-2" key={index}>
//                                     <div className="col-md-10">
//                                       <InputField
//                                         name={`secondaryMobiles.${index}`}
//                                         values={values}
//                                         touched={touched}
//                                         errors={errors}
//                                         placeholder={`Secondary Mobile ${index + 1
//                                           }`}
//                                       />
//                                     </div>

//                                     <div className="col-md-2 d-flex align-items-end">
//                                       <button
//                                         type="button"
//                                         className="btn btn-danger btn-sm"
//                                         onClick={() =>
//                                           arrayHelpers.remove(index)
//                                         }
//                                       >
//                                         X
//                                       </button>
//                                     </div>
//                                   </div>
//                                 )
//                               )}
//                             </>
//                           )}
//                         />
//                       </div>

//                       {/* Save / Cancel */}
//                       <div className="mt-4">
//                         <button type="submit" className="btn btn-theme me-2">
//                           Save
//                         </button>
//                         <button
//                           type="button"
//                           className="btn btn-border"
//                           onClick={() =>
//                             frProUser?.updateProfileForm?.businessName
//                               ? setSaving(true)
//                               : setSelection("")
//                           }
//                         >
//                           Cancel
//                         </button>
//                       </div>
//                     </div>
//                   </div>
//                 </div>
//               </div>
//             </form>
//           )}
//         </Formik>
//       )}

//       {toasts && <Toasts toastsList={toasts} />}
//     </div>
//   );
// };

// FleetBusinessSummary.propTypes = {
//   setSelection: PropTypes.func,
// };

// export default FleetBusinessSummary;
import React, { useState } from 'react'
import { Formik, Form } from 'formik'
import * as Yup from 'yup'
import PropTypes from 'prop-types'
import { useSelector } from 'react-redux'
import InputField from '../../../../Components/inputField'
import { ProfileApis } from '../../../../API/Login/ProfileApi'
import ErrorHandle from '../../../../Components/ErrorHandle'
import Toasts from '../../../../Components/Toasts/Toasts'

const FleetBusinessFullForm = ({ setSelection }) => {
  const { frProUser } = useSelector((state) => state.Users)
  const [saving, setSaving] = useState(false)
  const [toasts, setToasts] = useState(null)

  const initialValues = {
    businessName: frProUser?.updateProfileForm?.businessName || '',
    businessLegalName: frProUser?.updateProfileForm?.businessLegalName || '',
    businessNumber: frProUser?.updateProfileForm?.businessNumber || '',
    einNumber: frProUser?.updateProfileForm?.einNumber || '',
    primaryEmail: frProUser?.email || frProUser?.updateProfileForm?.primaryEmail || '',
    secondaryEmail: frProUser?.updateProfileForm?.secondaryEmail || '',
    primaryMobileCountryCode: frProUser?.updateProfileForm?.primaryMobileCountryCode || '',
    primaryMobileNumber: frProUser?.updateProfileForm?.primaryMobileNumber || '',
    secondaryMobileCountryCode: frProUser?.updateProfileForm?.secondaryMobileCountryCode || '',
    secondaryMobileNumber: frProUser?.updateProfileForm?.secondaryMobileNumber || '',
    faxNumber: frProUser?.updateProfileForm?.faxNumber || '',
    website: frProUser?.updateProfileForm?.website || '',
    // Address fields
    addressLine1: frProUser?.updateProfileForm?.bussAddressForm?.addressLine1 || '',
    addressLine2: frProUser?.updateProfileForm?.bussAddressForm?.addressLine2 || '',
    area: frProUser?.updateProfileForm?.bussAddressForm?.area || '',
    landmark: frProUser?.updateProfileForm?.bussAddressForm?.landmark || '',
    cityName: frProUser?.updateProfileForm?.bussAddressForm?.cityName || '',
    stateName: frProUser?.updateProfileForm?.bussAddressForm?.stateName || '',
    countryName: frProUser?.updateProfileForm?.bussAddressForm?.countryName || '',
    zipCode: frProUser?.updateProfileForm?.bussAddressForm?.zipCode || '',
    mapLink: frProUser?.updateProfileForm?.bussAddressForm?.mapLink || '',
    latitude: frProUser?.updateProfileForm?.bussAddressForm?.latitude || '',
    longitude: frProUser?.updateProfileForm?.bussAddressForm?.longitude || '',
    sameAsBillingAddress: frProUser?.updateProfileForm?.bussAddressForm?.sameAsBillingAddress || false,
    addressType: frProUser?.updateProfileForm?.bussAddressForm?.addressType || 'BUSINESS',
    keywords: frProUser?.updateProfileForm?.keywords ? frProUser?.updateProfileForm?.keywords.join(', ') : '',
    servicesOfferred: frProUser?.updateProfileForm?.servicesOfferred ? frProUser?.updateProfileForm?.servicesOfferred.join(', ') : '',
  }

  const validationSchema = Yup.object().shape({
    businessName: Yup.string().required('Business name is required'),
    businessLegalName: Yup.string().required('Legal business name is required'),
    businessNumber: Yup.string().nullable(),
    einNumber: Yup.string().nullable(),
    primaryEmail: Yup.string().email('Invalid email'),
    primaryMobileNumber: Yup.string().nullable(),
    cityName: Yup.string().nullable(),
    stateName: Yup.string().nullable(),
    countryName: Yup.string().nullable(),
    zipCode: Yup.string().nullable(),
    latitude: Yup.number().nullable().typeError('Latitude must be a number'),
    longitude: Yup.number().nullable().typeError('Longitude must be a number'),
  })

  const handleSubmit = async (values, helpers) => {
    setSaving(true)
    try {
      // Build payload - follow your API shape
      const payload = {
        ...frProUser?.updateProfileForm,
        fre8ProAccessToken: frProUser?.fre8ProAccessToken,
        businessName: values.businessName,
        businessLegalName: values.businessLegalName,
        businessNumber: values.businessNumber,
        einNumber: values.einNumber,
        primaryEmail: values.primaryEmail,
        secondaryEmail: values.secondaryEmail,
        primaryMobileCountryCode: values.primaryMobileCountryCode,
        primaryMobileNumber: values.primaryMobileNumber,
        secondaryMobileCountryCode: values.secondaryMobileCountryCode,
        secondaryMobileNumber: values.secondaryMobileNumber,
        faxNumber: values.faxNumber,
        website: values.website,
        keywords: values.keywords ? values.keywords.split(',').map((k) => k.trim()) : [],
        servicesOfferred: values.servicesOfferred ? values.servicesOfferred.split(',').map((s) => s.trim()) : [],
        bussAddressForm: {
          ...frProUser?.updateProfileForm?.bussAddressForm,
          addressLine1: values.addressLine1,
          addressLine2: values.addressLine2,
          area: values.area,
          landmark: values.landmark,
          cityName: values.cityName,
          stateName: values.stateName,
          countryName: values.countryName,
          zipCode: values.zipCode,
          mapLink: values.mapLink,
          latitude: values.latitude !== '' ? Number(values.latitude) : 0,
          longitude: values.longitude !== '' ? Number(values.longitude) : 0,
          sameAsBillingAddress: !!values.sameAsBillingAddress,
          addressType: values.addressType,
        },
      }

      // Call API
      await ProfileApis.updateFleetOwnerUserProfile(payload)

      setToasts([
        {
          name: 'Business profile updated successfully',
          type: 'Success',
        },
      ])
      // keep saving true or flip to view
      setTimeout(() => {
        setToasts(null)
        setSaving(false)
        if (typeof setSelection === 'function') setSelection('')
      }, 1500)
    } catch (err) {
      let customMessage = 'User Business summary update failed'
      let type = 'User Profile'
      let color = 'red'
      ErrorHandle(err, setToasts, customMessage, type, color)
      setSaving(false)
    } finally {
      helpers.setSubmitting(false)
    }
  }

  return (
    <div className="container-fluid py-3">
      {/* optional: preview of your provided image */}
      <div className="mb-3">
        <img
          src="/mnt/data/f296b6c9-d1e2-4201-9c84-165ea18b1ba7.png"
          alt="reference"
          style={{ maxWidth: '200px', width: '100%', height: 'auto' }}
        />
      </div>

      <Formik
        initialValues={initialValues}
        validationSchema={validationSchema}
        onSubmit={handleSubmit}
        enableReinitialize
      >
        {({ errors, values, isSubmitting, touched, handleSubmit }) => (
          <Form onSubmit={handleSubmit}>
            {/* Business summary */}
            <div className="mb-4 p-4 shadow-sm rounded-4 bg-white">
              <div className="d-flex justify-content-between align-items-start">
                <h5 className="fw-bold mb-0">Business summary</h5>
                <div>
                  <button type="button" className="btn btn-sm" onClick={() => setSelection && setSelection('')}>
                    Cancel
                  </button>
                </div>
              </div>

              <div className="row mt-3 g-3">
                <div className="col-md-6">
                  <label className="form-label">Business name <span className="text-danger">*</span></label>
                  <InputField name="businessName" values={values} touched={touched} errors={errors} />
                </div>

                <div className="col-md-6">
                  <label className="form-label">Legal business name <span className="text-danger">*</span></label>
                  <InputField name="businessLegalName" values={values} touched={touched} errors={errors} />
                </div>

                <div className="col-md-6">
                  <label className="form-label">Business number</label>
                  <InputField name="businessNumber" values={values} touched={touched} errors={errors} />
                </div>

                <div className="col-md-6">
                  <label className="form-label">EIN number</label>
                  <InputField name="einNumber" values={values} touched={touched} errors={errors} />
                </div>

                <div className="col-12">
                  <label className="form-label">Services offered (comma separated)</label>
                  <InputField name="servicesOfferred" values={values} touched={touched} errors={errors} />
                </div>

                <div className="col-12">
                  <label className="form-label">Keywords (comma separated)</label>
                  <InputField name="keywords" values={values} touched={touched} errors={errors} />
                </div>
              </div>
            </div>

            {/* Contact details */}
            <div className="mb-4 p-4 shadow-sm rounded-4 bg-white">
              <h5 className="fw-bold mb-3">Contact details</h5>
              <div className="row g-3">
                <div className="col-md-6">
                  <label className="form-label">Primary email</label>
                  <InputField name="primaryEmail" values={values} touched={touched} errors={errors} />
                </div>

                <div className="col-md-6">
                  <label className="form-label">Secondary email</label>
                  <InputField name="secondaryEmail" values={values} touched={touched} errors={errors} />
                </div>

                <div className="col-md-3">
                  <label className="form-label">Primary mobile country code</label>
                  <InputField name="primaryMobileCountryCode" values={values} touched={touched} errors={errors} />
                </div>

                <div className="col-md-3">
                  <label className="form-label">Primary mobile number</label>
                  <InputField name="primaryMobileNumber" values={values} touched={touched} errors={errors} />
                </div>

                <div className="col-md-3">
                  <label className="form-label">Secondary mobile country code</label>
                  <InputField name="secondaryMobileCountryCode" values={values} touched={touched} errors={errors} />
                </div>

                <div className="col-md-3">
                  <label className="form-label">Secondary mobile number</label>
                  <InputField name="secondaryMobileNumber" values={values} touched={touched} errors={errors} />
                </div>

                <div className="col-md-6">
                  <label className="form-label">Fax</label>
                  <InputField name="faxNumber" values={values} touched={touched} errors={errors} />
                </div>

                <div className="col-md-6">
                  <label className="form-label">Website</label>
                  <InputField name="website" values={values} touched={touched} errors={errors} />
                </div>
              </div>
            </div>

            {/* Address */}
            <div className="mb-4 p-4 shadow-sm rounded-4 bg-white">
              <div className="d-flex justify-content-between">
                <h5 className="fw-bold mb-0">Address</h5>
                <small className="text-muted align-self-center">Address type</small>
              </div>

              <div className="row g-3 mt-3">
                <div className="col-md-12">
                  <label className="form-label">Address Line 1</label>
                  <InputField name="addressLine1" values={values} touched={touched} errors={errors} />
                </div>

                <div className="col-md-12">
                  <label className="form-label">Address Line 2</label>
                  <InputField name="addressLine2" values={values} touched={touched} errors={errors} />
                </div>

                <div className="col-md-4">
                  <label className="form-label">Area</label>
                  <InputField name="area" values={values} touched={touched} errors={errors} />
                </div>

                <div className="col-md-4">
                  <label className="form-label">Landmark</label>
                  <InputField name="landmark" values={values} touched={touched} errors={errors} />
                </div>

                <div className="col-md-4">
                  <label className="form-label">ZIP / Postal Code</label>
                  <InputField name="zipCode" values={values} touched={touched} errors={errors} />
                </div>

                <div className="col-md-4">
                  <label className="form-label">City</label>
                  <InputField name="cityName" values={values} touched={touched} errors={errors} />
                </div>

                <div className="col-md-4">
                  <label className="form-label">State</label>
                  <InputField name="stateName" values={values} touched={touched} errors={errors} />
                </div>

                <div className="col-md-4">
                  <label className="form-label">Country</label>
                  <InputField name="countryName" values={values} touched={touched} errors={errors} />
                </div>

                <div className="col-md-6">
                  <label className="form-label">Map link</label>
                  <InputField name="mapLink" values={values} touched={touched} errors={errors} />
                </div>

                <div className="col-md-3">
                  <label className="form-label">Latitude</label>
                  <InputField name="latitude" values={values} touched={touched} errors={errors} />
                </div>

                <div className="col-md-3">
                  <label className="form-label">Longitude</label>
                  <InputField name="longitude" values={values} touched={touched} errors={errors} />
                </div>

                <div className="col-12 d-flex align-items-center gap-3">
                  <div className="form-check">
                    <FieldCheckBox name="sameAsBillingAddress" values={values} />
                  </div>
                  <div>
                    <label className="form-label mb-0">Same as billing address</label>
                  </div>
                </div>
              </div>
            </div>

            {/* Actions */}
            <div className="mb-4 d-flex gap-2">
              <button type="submit" className="btn btn-theme" disabled={isSubmitting || saving}>
                {saving || isSubmitting ? 'Saving...' : 'Save'}
              </button>
              <button
                type="button"
                className="btn btn-border"
                onClick={() => (frProUser?.updateProfileForm?.businessName ? setSaving(true) : setSelection(''))}
              >
                Cancel
              </button>
            </div>
          </Form>
        )}
      </Formik>

      {toasts && <Toasts toastsList={toasts} />}
    </div>
  )
}

// small checkbox helper that uses your InputField shape
const FieldCheckBox = ({ name, values }) => {
  // Render using your InputField API: tag omitted, but InputField handles checkbox type
  return (
    <InputField
      type="checkbox"
      name={name}
      values={values}
      touched={{}}
      errors={{}}
      // checkVal prop to control checkbox checked value
      checkVal={!!values[name]}
      onChange={() => {
        // toggle using DOM event handled by Formik Field inside InputField
        // InputField uses setFieldTouched/setFieldValue via useFormikContext; if you need setFieldValue here,
        // you can wire it up, but the basic InputField supports "onChange" prop.
      }}
    />
  )
}

FieldCheckBox.propTypes = {
  name: PropTypes.string.isRequired,
  values: PropTypes.object,
}

FleetBusinessFullForm.propTypes = {
  setSelection: PropTypes.func,
}

export default FleetBusinessFullForm